import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'imageGetFolder'
})
export class ImageGetFolderPipe implements PipeTransform {

    /* Extract folder name from image full file name */
    transform(image: String): String {
        if (image) {
            return image.substring(image.indexOf('_') + 1, image.lastIndexOf('_'));
        }
    }

}



// WEBPACK FOOTER //
// ./src/app/pipes/image-get-folder.pipe.ts